/** @module Auth0Logger */
/* eslint-disable import/extensions */
import Auth0LoggerConsole from './auth0-logger-console.mjs';
import Auth0LoggerSumoLogic from './auth0-logger-sumologic.mjs';

class Auth0Logger {
  static async log(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.log(msg));
    await Promise.all(loggerPromises);
  }

  static async trace(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.trace(msg));
    await Promise.all(loggerPromises);
  }

  static async debug(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.debug(msg));
    await Promise.all(loggerPromises);
  }

  static async info(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.info(msg));
    await Promise.all(loggerPromises);
  }

  static async warn(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.warn(msg));
    await Promise.all(loggerPromises);
  }

  static async error(msg) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.error(msg));
    await Promise.all(loggerPromises);
  }

  static async logMetric(metric) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.logMetric(metric));
    await Promise.all(loggerPromises);
  }

  static async logCountMetric(metric) {
    if (!this.loggerEndpoints.length) return Promise.resolve();
    const loggerPromises = this.loggerEndpoints.map(logger => logger.logCountMetric(metric));
    await Promise.all(loggerPromises);
  }

  static get loggerEndpoints() {
    if (!this._endpoints) {
      // default init
      this.initialize();
    }

    return this._endpoints;
  }

  static initialize = (options = {}) => {
    console.log(`initialize logger => ${JSON.stringify(options)}`);

    // Store tenantClass for auto-injection into all log messages
    this._tenantClass = options.tenantClass ?? null;

    this._endpoints = [
      new Auth0LoggerConsole(options),
    ];

    if (options.sumoEndpoint) {
      this._endpoints.push(new Auth0LoggerSumoLogic(options));
    }

    // TODO sentry logger
  };

  /**
   * Set the tenant class after initialization (useful when tenant is resolved later)
   * @param {string} tenantClass - Tenant class (e.g., 'shipstation', 'shipstation-partners')
   */
  static setTenantClass = (tenantClass) => {
    this._tenantClass = tenantClass ?? null;
    // Propagate to all endpoints
    (this._endpoints ?? []).forEach((endpoint) => {
      if (typeof endpoint.setTenantClass === 'function') {
        endpoint.setTenantClass(tenantClass);
      }
    });
  };

  /**
   * Get the current tenant class
   * @returns {string|null}
   */
  static get tenantClass() {
    return this._tenantClass ?? null;
  }

  static addLogger(logger) {
    if (!this._endpoints) {
      // default init
      this.initialize();
    }
    this._endpoints.push(logger);
  }
}

export default Auth0Logger;
